import { z } from 'zod';

export const CrmCustomerCreditSchema = z.object({
    id: z.string(),
    customerId: z.string(),
    balance: z.number(),
    lifetimeEarned: z.number(),
    lifetimeSpent: z.number(),
});

export type CrmCustomerCredit = z.infer<typeof CrmCustomerCreditSchema>;

export const CrmCustomerCreditsSchema = z.object({
    email: z.string(),
    storeId: z.string(),
    credits: z.array(CrmCustomerCreditSchema),
    totalAvailableCredits: z.number(),
});

export type CrmCustomerCredits = z.infer<typeof CrmCustomerCreditsSchema>;
